import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  FieldValues,
  UpdateDocumentsProvider,
  UpdateDocumentsResult,
  UserFriendlyError,
} from 'models';
import { Observable, map } from 'rxjs';
import { S9ApiUpdateDocumentsResult, createS9ApiFieldValue } from '../models';
import { SQUARE9_API_CONFIG } from './square9-api-config.token';

/** Square 9 API update documents service. */
@Injectable({
  providedIn: 'root',
})
export class Square9ApiUpdateDocumentsService
  implements UpdateDocumentsProvider
{
  private config = inject(SQUARE9_API_CONFIG);
  private http = inject(HttpClient);
  private apiUrl = toSignal(this.config.apiUrl$, { initialValue: '' });
  private baseUrl = computed(() => `${this.apiUrl()}/UpdateDocuments`);

  /** @inheritdoc */
  updateFieldData(
    databaseId: number,
    archiveId: number,
    documents: Record<number, string>,
    fieldValues: FieldValues
  ): Observable<UpdateDocumentsResult> {
    const apiFieldValues = fieldValues.map((fieldValue) =>
      createS9ApiFieldValue(fieldValue)
    );
    return this.http
      .put<S9ApiUpdateDocumentsResult>(
        `${this.baseUrl()}/databases/${databaseId}/archive/${archiveId}/FieldData`,
        {
          // biome-ignore lint/style/useNamingConvention: The API expects pascal case.
          Documents: documents,
          // biome-ignore lint/style/useNamingConvention: The API expects pascal case.
          FieldData: apiFieldValues,
        }
      )
      .pipe(
        map((apiResult) => {
          const result: UpdateDocumentsResult = {
            errors: {},
          };
          for (const documentId in apiResult.Errors) {
            const documentIdAsNumber = Number(documentId);

            const userFriendlyError = new UserFriendlyError(
              apiResult.Errors[documentId]
            );
            userFriendlyError.i18n =
              'GENERIC_FAILED_TO_UPDATE_DOCUMENT_INDEX_DATA';
            result.errors[documentIdAsNumber] = userFriendlyError;
          }
          return result;
        })
      );
  }
}
